import { render } from "./InlinePublicPdfViewer.vue?vue&type=template&id=9f57e3ce&ts=true"
import script from "./InlinePublicPdfViewer.vue?vue&type=script&lang=ts"
export * from "./InlinePublicPdfViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__